const STORAGE_KEY = 'cartamodelli-branding'

export interface BrandingState {
  logoBase64?: string
  name?: string
  accentColor?: string
}

export function getBranding(): BrandingState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as BrandingState) : {}
  } catch {
    return {}
  }
}

export function setBranding(state: BrandingState): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}

export function clearBranding(): void {
  localStorage.removeItem(STORAGE_KEY)
}
